_getUserPortalData